import Vue from "vue";
import { store } from "../store";
import VueRouter from "vue-router";

import routes from "./routes";

Vue.use(VueRouter);

const router = new VueRouter({
  // linkActiveClass: "list__title--active",
  mode: "history",
  routes: routes
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.forVisitors)) {
    if (store.getters["AuthModule/isAuthenticated"]) next({ path: "/" });
    next();
  } else if (to.matched.some(record => record.meta.forAuth)) {
    if (!store.getters["AuthModule/isAuthenticated"]) {
      next({ path: "/auth/login" });
    } else {
      if (to.matched.some(record => record.meta.can)) {
        let permissions = store.getters["AuthModule/permissions"];
        if (permissions.includes(to.meta.can)) {
          next();
        } else {
          next("/401");
        }
      } else {
        next();
      }
    }
  }
});
export default router;
